import ContactComponent from "../../components/aloqa/Aloqa";
const Contact = () => {
  return (
    <div className="mx-auto bg-[#EFEFEF]">
      <ContactComponent />
    </div>
  );
};

export default Contact;
